export const AMERICAN_FORMAT_LANGUAGES = ['en'];
export const AMERICAN_FORMAT_LANGUAGE_CODES = ['en-US'];

export function isEuropeanLanguage(language: string): boolean {
    return !AMERICAN_FORMAT_LANGUAGES.includes(language);
}

export function isEuropeanLanguageCode(languageCode: string): boolean {
    return !AMERICAN_FORMAT_LANGUAGE_CODES.includes(languageCode);
}

export function getDateFormat(language: string): string {
    return isEuropeanLanguage(language) ? 'd MMM H:mm' : 'd MMM h:mm a';
}

export function getFullDateFormat(language: string): string {
    return isEuropeanLanguage(language) ? 'd MMM yy H:mm' : 'd MMM yy h:mm a';
}

export function getTimeFormat(language: string): string {
    return isEuropeanLanguage(language) ? 'H:mm' : 'h:mm a';
}

/** Maps a full locale code to the short code registered with i18n-iso-countries (only en/de/it are registered there). */
export function getRegisteredCountriesLocale(languageCode: string): string {
    return languageCode === 'de-DE' ? 'de' : languageCode === 'it-IT' ? 'it' : 'en';
}
